import styled from 'styled-components'
import { mediaQueries } from '@centivo/react-components'

const SearchBarMessage = styled.ul`
  list-style-type: disc;

  @media ${mediaQueries.desktop} {
    width: 670px;
  }
`

const BulletPoint = styled.li`
  color: #212121;
  font-family: AnekGujarati;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  letter-spacing: 0.28px;
  margin-bottom: 10px;
  line-height: 140%;
`

const BulletPointBold = styled(BulletPoint)`
  font-weight: 600;
`

const MemberPortalLink = styled.a`
  color: #5e58f6;
  font-family: AnekGujarati;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  letter-spacing: 0.28px;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
`

const ProviderRelationsLink = styled.a`
  color: #212121;
  font-family: AnekGujarati;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  letter-spacing: 0.28px;
  margin-bottom: 10px;
  line-height: 140%;
`

const SearchBarAside = () => (
  <aside>
    <SearchBarMessage>
      <BulletPointBold>
        Before scheduling an appointment, please check the Centivo app or{' '}
        <MemberPortalLink
          href="https://my.centivo.com/"
          target="_blank"
          rel="noreferrer"
        >
          my.centivo.com
        </MemberPortalLink>{' '}
        to make sure the provider is in-network for your plan.
      </BulletPointBold>
      <BulletPoint>
        We recommend calling a provider’s office directly to verify that the
        information is still current. Appointment availability may vary.
      </BulletPoint>
      <BulletPoint>
        If something looks incorrect in the directory, please email us at{' '}
        <ProviderRelationsLink href="mailto:ProviderRelations@centivo.com">
          ProviderRelations@centivo.com
        </ProviderRelationsLink>
        .
      </BulletPoint>
    </SearchBarMessage>
  </aside>
)

export default SearchBarAside
